import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 269 590"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F4F8F8",
      d: "M0 19.477v569.312c88.836 14.482 269-101.877 269-298.14C269 164.801 168.686 0 56.894 0 13.475 0 0 19.477 0 19.477"
    }, null, -1)
  ])))
}
export default { render: render }